import React from 'react'
// Ant Design
import { Flex, Typography, Skeleton, Pagination } from 'antd'
// Ant Design Icons
import { FolderOutlined } from '@ant-design/icons'
// Config
import { getConfig } from '../../config'
const { Text  } = Typography

export const ContentList = ({ t, select, setSelect, reports, loading, setChangeGraph, page, setPage, total }) => {

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        
        return `${day}/${month}/${year}`;
    };

    function SkeletonList() {
        return (
            Array.from({ length: 7 }).map((_, index) => (
                <Flex key={index} align="center" style={{ minHeight: "80px" }}>
                    <Skeleton.Avatar active size="large" shape="square" />
                    <Flex vertical style={{ marginLeft: "10px" }}>
                        <Skeleton.Input active size="small" />
                        <Skeleton.Input active size="small" style={{ marginTop: "5px" }} />
                    </Flex>
                </Flex>
            ))
        )
    }

    function List() {

        const onReport = (report) => {
            setSelect(report)
            setChangeGraph(false)
        }

        return (
            <>
                {reports && reports.map((report, index) => (
                    <Flex key={index+1} onClick={() => onReport(report)} align="center" style={{ minHeight: "80px", paddingRight: "10px", cursor: "pointer", boxShadow: (select && select._id === report._id) && "0px 6px 12px rgba(0, 0, 0, 0.2)", transition: "box-shadow 0.3s ease" }}>
                        <FolderOutlined style={{ fontSize: "35px", marginRight: "10px", color: getConfig("colorSecundario") }} />
                        <Flex vertical>
                            <Text style={{ fontSize: "15px", fontWeight: "600" }}>{report.report_name}</Text>
                            <Text style={{ fontSize: "12px", color: "#BFBFBF" }}><span>{t("date")}</span>: {formatDate(report.created_at)}</Text>
                        </Flex>
                    </Flex>
                ))}
            </>
        )
    }

    return (
        <Flex className="skin-scroll" vertical style={{ position: "relative", width: "25%", height: "calc(100vh - 70px)", overflowY: "auto", borderRight: `2px solid ${getConfig("colorPrimario")}` }}>
            {loading ? <SkeletonList /> : <List />}
            
            <Flex justify="center" style={{ position: "sticky", width: "100%", bottom: 0, left: 0, backgroundColor: "#fff", zIndex: "1" }}>
                <Pagination 
                    simple={{ readOnly: true }}
                    current={page} 
                    onChange={(newPage) => setPage(newPage)} 
                    total={total}
                    pageSize={10}
                    showSizeChanger={false}
                />
            </Flex>
        </Flex>
    )
}
